module.exports = "mutation resetPasswordRequest($email:String!,$urlPrefix:String!){resetPasswordRequest(email:$email,urlPrefix:$urlPrefix)}"